var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { Link } from 'react-router';
import { InformationCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import { Translate } from "../../../../../I18N";

const HTMLNotification = () => /*#__PURE__*/
_jsx("div", { className: "flex items-center gap-4 p-4 text-primary-700 border-primary-300 bg-primary-100 w-fit" }, void 0, /*#__PURE__*/
_jsx(InformationCircleIcon, { className: "w-7 h-7" }), /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Use"), "\xA0", /*#__PURE__*/
_jsx(Link, {
  className: "underline hover:text-primary-800",
  target: "_blank",
  to: "https://guides.github.com/features/mastering-markdown/",
  rel: "noopener noreferrer" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Markdown")
), "\xA0", /*#__PURE__*/

_jsx(Translate, {}, void 0, "syntax to create page content"), ".\xA0", /*#__PURE__*/
_jsx(Translate, {}, void 0, "You can also embed advanced components like maps, charts and entity lists in your page."

), "\xA0", /*#__PURE__*/

_jsx(Link, {
  className: "underline hover:text-primary-800",
  target: "_blank",
  to: "https://uwazi.readthedocs.io/en/latest/admin-docs/analysing-and-visualising-your-collection.html",
  rel: "noopener noreferrer" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Click here")
), "\xA0", /*#__PURE__*/

_jsx(Translate, {}, void 0, "to learn more about the components.")
)
);


const JSNotification = () => /*#__PURE__*/
_jsx("div", { className: "flex items-center gap-4 p-4 text-warning-700 border-warning-300 bg-warning-100 w-fit" }, void 0, /*#__PURE__*/
_jsx(ExclamationTriangleIcon, { className: "w-7 h-7" }), /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "With great power comes great responsibility!"), /*#__PURE__*/
_jsx("br", {}), /*#__PURE__*/
_jsx(Translate, {}, void 0, "This area allows you to append custom Javascript to the page. This opens up a new universe of possibilities."


), "\xA0", /*#__PURE__*/

_jsx(Translate, {}, void 0, "It could also very easily break the app. Only write code here if you know exactly what you are doing."


)
)
);


export { HTMLNotification, JSNotification };